<template>
  <div>
	<!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow class="waste-request-main">
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Edit Waste Request</strong>
          </CCardHeader>
          <CCardBody>
			<CForm class="formData waste-form-main">
            <CRow>
             <CCol sm="12" class="mb-3">										
                <!--<CSelect
                  label="Select Site"
                  :options="siteOptions"
                />-->
              <label class="m-0 col-fonts-black">Select Site</label>
              <v-select :options="siteOptions" v-model="siteOptionsSelected" placeholder="Select Site" @input="siteSel"></v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" class="mb-3">    
				<label class="m-0 col-fonts-black">Select Customer</label>
              <v-select :options="customerOptions"  placeholder="Select Customer" @input="customerSel"></v-select>
			  <!---<CInput
                  label="Customer Name"
                  placeholder="Customer Name" name="CustomerName" :value="CustomerName"/>--->
              </CCol>
            </CRow>
            <CRow class="mb-2 counterDiv">
              <CCol md="6" class="mb-3">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Oldest O/S Amt</h5>
                              <p class="m-0 col-green fw-500">₹ <span id="oldest_os_amt">{{oldest_os_amt}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Ageing Days</h5>
                              <p class="m-0 fw-500 col-fonts-grey"><span id="oldest_days">{{oldest_days}}</span></p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1 fw-500">Invoice Number</h5>
                              <p class="m-0 fw-500 col-fonts-grey"><span id="invoice_number">{{invoice_number}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1"></h5>
                              <p class="m-0 fw-500 col-fonts-grey"></p>
                            </div>
                          </CCol>
                        </CCol>
                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>

              <CCol md="6" class="mb-3">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">OutStanding Amt</h5>
                              <p class="m-0 col-green fw-500">₹ <span id="outstanding_amt">{{outstanding_amt}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Ageing info</h5>
                              <p class="m-0 fw-500"><u><i><a class="col-yellow" @click="agentinfo">Click Here</a></i></u></p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">PCB Valid Upto</h5>
                              <p class="m-0 fw-500 col-fonts-grey" id="PCB_Valid_Date">{{PCB_Valid_Date}}</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Membership Valid Upto</h5>
                              <p class="m-0 fw-500 col-fonts-grey" id="Membership_Valid_Date">{{Membership_Valid_Date}}</p>
                            </div>
                          </CCol>
                        </CCol>
                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>
            </CRow>
            <CRow>
             <CCol sm="12" class="mb-3">
                <!--<CSelect
                  label="Waste Name"
                  :options="wastename"
                />-->
				<label class="m-0 col-fonts-black">Waste Name</label>
				<v-select :options="wastename" placeholder="Select Waste Name" @input="wasteSel"></v-select>
              </CCol>
            </CRow>
            <CRow>
				<CCol  :col="12" class="p-0 d-flex">
					<CCol :col="6">
					  <CInput
						label="Physical Status"
						placeholder=""
						name="physicalStatus" :value="physicalStatus"
						disabled
					  />
					<!-- <label class="m-0 col-fonts-black">Physical Status</label>
					<v-select :options="physicalOptions" placeholder="Select Status" @input="physicalSel"></v-select> -->
				   </CCol>
				   <CCol :col="6">
            <CInput
              label="Lifting Date"
              type="date" :min="currentdate" :max="lastdate" :value="currentdate" id="VehiclePlaceDate"
              />
              </CCol>		
				</CCol>   
			</CRow>
			<CRow>
        <CCol :col="12" class="p-0 d-flex flex-column">               
        <CCol class="otherOptions col-sm-12 p-0 d-flex">
                			
				   <CCol :col="6">
					<CInput
						label="Lifting Time"
						type="Time" id="VehiclePlaceTime"	
					  />
				   </CCol>
               <CCol :col="6">
                  <!-- <CSelect
                  label="Month"
                  :options="wasteqty" id="wasteqty"
                /> -->
                <label class="m-0 col-fonts-black">Vehicle Capacity</label>
                <v-select :options="capacity" placeholder="Select" id="capacitySel" @input="capacitySel"></v-select>
				<CInput type="text" value="" id="VehicleCapacity"/>
               </CCol>
            </CCol>
          </CCol>

        <CCol :col="12" class="p-0 d-flex flex-column">               
              <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex">
               <CCol :col="6">
                 	<label class="m-0 col-fonts-black">Shipment</label>
                  <v-select :options="shipmentArr" placeholder="Select" @input="shipmentSel"></v-select>
                   <!-- <CSelect
                  label="Shipment"
                  :options="wasteshipment" id="shipmentid" name="shipmentid"
                /> -->
               </CCol>

               <CCol :col="6">
                 <label class="m-0 col-fonts-black">Packaging</label>
                  <v-select :options="packagingArr" placeholder="Select" @input="packagingSel"></v-select>

                   <!-- <CSelect
                  label="Packaging"
                  :options="wastepackaging" id="wastepackaging"
                /> -->
               </CCol>
              </CCol>
          </CCol>

             <CCol :col="12" class="p-0 d-flex flex-column">
              <CCol class="otherOptions col-sm-12 mb-3 p-0 d-flex">

               <CCol sm="6">
                  <label class="m-0 col-fonts-black">Texture</label>
                  <v-select :options="textureArr" class="asdad" placeholder="Select" @input="textureSel"></v-select>

                   <!-- <CSelect
                  label="Texture"
                  :options="wastetexture" id="wastetexture"
                /> -->
               </CCol>

               <CCol sm="6">
                 <label class="m-0 col-fonts-black">Truck Type</label>
                  <v-select :options="truckArr" placeholder="Select" @input="truckTypeSel"></v-select>

                   <!-- <CSelect
                  label="Truck Type"
                  :options="wastetrucktype" id="wastetrucktype"
                /> -->
               </CCol>
              </CCol>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label="Remarks"
                  placeholder="Content..." id="Remarks" :value="Remarks"
                  verticle
                  rows="4"
                />
              </CCol>
            </CRow>
            <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18 mb-2" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Submit</button>
			</CCol>
			 
            </CRow>
			<CModal
			  :show.sync="myModal"
			  :no-close-on-backdrop="true"
			  :centered="true"
			  title="Agent Info"
			  color="dark"
        class="agent-info-popup"
			>
          <CRow>
            <CCol sm="12"  class="outing-title">
              {{outTitle}}
            </CCol>
          </CRow>
          <CRow sm="12">
              <CCol sm="4">
                  <ul>
                    <li>0-30 Days</li>
                    <li>₹ {{days30}}</li>
                  </ul>
              </CCol>
              <CCol sm="4">
                <ul>
                  <li>0-30 Days</li>
                  <li>₹ {{days60}}</li>
                </ul>
              </CCol>
              <CCol sm="4">
                <ul>
                  <li>0-30 Days</li>
                  <li>₹ {{days180}}</li>
                </ul>
              </CCol>
          </CRow>

          <CRow sm="12">
              <CCol sm="4">
                  <ul>
                    <li>0-30 Days</li>     
                    <li>₹ {{days270}}</li>
                  </ul>
              </CCol>
              <CCol sm="4">
                <ul>
                  <li>0-30 Days</li>
                  <li>₹ {{days365}}</li>
                </ul>
              </CCol>
              <CCol sm="4">
                <ul>
                  <li>0-30 Days</li>
                  <li>₹ {{days365up}}</li>
                </ul>
              </CCol>
          </CRow>
			  
			  <!-- <template #header>
				<h6 class="modal-title"></h6>
				<CButtonClose @click="myModal = false" class="text-white"/>
			  </template> -->
			  <template #footer>
			    <CButton @click="myModal = false" color="primary">Close</CButton>				
			  </template>
			</CModal>  
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Edit_waste_lifting',
 data () {
    return {
		isLoading: false,
    myModal: false,
    currentdate:'',
    lastdate:'',
      setSelected:"",	  
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],     
      siteOptions : [],
	  siteOptionsSelected:"",
	  customerOptions:[],
	  customerfullArr:[],
      siteArr : [],
	  siteuniArr : [],
	  CustomerName:'',
      physicalArr : [],
	  physicalStatus:'',
      shipmentArr : [],
      packagingArr : [],
      textureArr : [],
      truckArr : [],
      siteCode : '',
	  Plant_Name:'',
	  Plant_Code:'',
      wasteCode : '',
      siteCustomerCode : '',
	  siteCustomer_Name:'',
	  PCB_Valid_Date:'00/00/0000 12:00 AM',
	  Membership_Valid_Date:'00/00/0000 12:00 AM',
	  Is_Quantity_Input:"",
	  CustomerAddress:'',
      physicalOptions : ['New physical','LIQUID'],      
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],
    wasteArr: [],	  
      capacity: [],
	  Quentity:0,
	  Shipment:'',
	  Packaging:'',
	  Texture:'',
	  TruckType:'',
	  Remarks:'',
	  Region:'',
    capacityArr: [],
	  oldest_os_amt:0,
	  oldest_days:0,
    oldestArr: [],
	  invoice_number:0,
	  outstanding_amt:0,
	  outTitle:'',
	  days30:0,
	  days60:0,
	  days180:0,
	  days270:0,
	  days365:0,
	  days365up:0,	  
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],
		IPAddress:"172.16.2.30",
		Latitude:"21.2354158452",
		Longitude:"72.89745852",
    }
  },
  mounted () {
	$('.counterDiv').hide();
	$('.otherOptions').hide();
	$('#VehicleCapacity').hide();				
  var today = new Date();
  // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
  var date = today.getFullYear()+'-'+((today.getMonth()+1)< 10 ? '0'+(today.getMonth()+1) : (today.getMonth()+1))+'-'+(today.getDate()< 10 ? '0'+today.getDate() : today.getDate());
  this.currentdate=date;
  //console.log(date);

  var maxdate = new Date();
  maxdate.setDate(maxdate.getDate() + 7);  
  var max = maxdate.getFullYear()+'-'+((maxdate.getMonth()+1)< 10 ? '0'+(maxdate.getMonth()+1) : (maxdate.getMonth()+1))+'-'+(maxdate.getDate() < 10 ? '0'+maxdate.getDate() : maxdate.getDate());
  //console.log(max);
  this.lastdate=max;
  
	var token=localStorage.getItem("auth");
	var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
	var self = this;
		var requestInfo = {	
      Token:token,
      Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'MasterData/GetSapSites',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		this.isLoading = true;
		axios(config)
		.then((result) => {	
			this.isLoading = false;		
			if(result.data.status_code==200){
        var obj=result.data.response;
        //console.log(obj)
        var siteOptionsArr=obj;		
		this.siteuniArr=obj;
		this.siteArr=obj;
		//console.log(obj);
        //this.siteArr=[];				
       // localStorage.removeItem("site_list", JSON.stringify([]));
       // localStorage.setItem("site_list", JSON.stringify(siteOptionsArr));		
        var siteSingleArr=[];		
		var customerArr=[];
        var selArr = siteOptionsArr.find(function(jsonitem, i){		
            
			if ($.inArray(jsonitem.Plant_Name, siteSingleArr) >= 0) {				
			}else{
				siteSingleArr.push(jsonitem.Plant_Name);				
			}
        });
		
        this.siteOptions=siteSingleArr;	

			}else{	
				this.isLoading = false;				
				//$('#reponse_error').html(result.data.message);
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
    }).catch(() => {
		this.isLoading = false;	
		this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: "Something went wrong!"		 
				})
	})
    this.isLoading = true;
     axios
      .get(apiURL+'MasterData/GetWasteMasterData')
      .then(result => {	
		  this.isLoading = false;		
          if(result.data.status_code==200){
            var shipmentArr=result.data.Shipment_Types;
            var packagingArr=result.data.Packaging_Types;
            var textureArr=result.data.Texture_Type;
            var truckArr=result.data.Truck_Type;
            //console.log(shipmentArr)

            self.siteArr=shipmentArr;
            var shipmentSingleArr=[];
            var selArr = shipmentArr.find(function(jsonitem, i){	
                shipmentSingleArr.push(jsonitem.Shipment_Type);				
            });		
            self.shipmentArr=shipmentSingleArr;

            self.siteArr=packagingArr;
            var pacakageSingleArr=[];
            var selArr = packagingArr.find(function(jsonitem, i){	
                pacakageSingleArr.push(jsonitem.Pack_Type);				
            });		
            self.packagingArr=pacakageSingleArr;

            self.siteArr=textureArr;
            var textureSingleArr=[];
            var selArr = textureArr.find(function(jsonitem, i){	
                textureSingleArr.push(jsonitem.Texture_Type);				
            });		
            self.textureArr=textureSingleArr; 

            self.siteArr=truckArr;
            var truckSingleArr=[];
            var selArr = truckArr.find(function(jsonitem, i){	
                truckSingleArr.push(jsonitem.Truck_Type);	
            });		
            self.truckArr=truckSingleArr; 

          }else{				            
            self.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: result.data.message		 
            })
          }
          
        })

		.catch((error) => {
			this.isLoading = false;
			//var errorObject=JSON.stringify(error.response.data.errors);			
			//console.log(errorObject);		   
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
    });

	fetch('https://api.ipify.org?format=json')
	.then(x => x.json())
	.then(({ ip }) => {
		self.IPAddress = ip;
		console.log(self.IPAddress);
	});
	
	const success = (position) => {	
		self.Latitude  = position.coords.latitude;
		self.Longitude = position.coords.longitude;
		console.log(self.Latitude+' '+self.Longitude);
	};

	const error = (err) => {
		console.log(error)
	};

	// This will open permission popup
	navigator.geolocation.getCurrentPosition(success, error);
	
	/* get waste request details*/
	var waste_edit_id=localStorage.getItem("waste_edit_id");
	var requestInfo = {	
      Token:token,
	  Item_Id:waste_edit_id,
      Session_User_Id:Session_User_Id,
	};
	var data = JSON.stringify(requestInfo);							
		var config = {
		  method: 'post',
		  url: apiURL+'MasterData/GetWasteRequestDetails',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
	};
	this.isLoading = true;
	axios(config)
	.then((result) => {	
		this.isLoading = false;		
		if(result.data.status_code==200){
			var obj=result.data.response;
			var selArr = obj.find(function(jsonitem, i){
				self.siteOptionsSelected=jsonitem.Site_Name;
				console.log(obj);
			});
		}
	}).catch(() => {
		this.isLoading = false;
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
	})
	
  },
  computed: {
        
   },
  methods: {
	/*dateformate(val){
		console.log('callll '+val);
		var sp=val.split('-');
		var redate=sp[2]+'/'+sp[1]+'/'+sp[0];
		this.currentdate=redate.replaceAll("-", "/");		
	},*/
    siteSel(value) {
      //console.log(value);    
       var self=this;
		var customerfullArr=[];
		var customerArr=[];
		var selArr = this.siteArr.find(function(jsonitem, i){
			if(jsonitem.Plant_Name==value){
				customerfullArr.push(jsonitem);
				customerArr.push(jsonitem.Customer_Name+'-'+jsonitem.Customer_Code);
			}
		});		
	   //console.log(customerfullArr);				
	   self.customerOptions=[];
       self.customerOptions=customerArr;
	   self.customerfullArr=customerfullArr;
    },
	customerSel(value) {
		 //console.log(value);
		 var Customer_Code=value.split('-');		 
		 var self=this;
		 var selArr = this.customerfullArr.find(function(jsonitem, i){		
          if(jsonitem.Customer_Code==Customer_Code[1]){
            //console.log(jsonitem.Customer_Name);
            //$('input[name=CustomerName]').val(jsonitem.Customer_Name);
            self.CustomerName='';
            self.CustomerName=jsonitem.Customer_Name;
            self.Plant_Name=jsonitem.Plant_Name;
            self.siteCode=jsonitem.Site_Code;
            self.Plant_Code=jsonitem.Plant_Code;
            self.siteCustomerCode=jsonitem.Customer_Code;
            self.siteCustomer_Name=jsonitem.Customer_Name;
            self.CustomerAddress=jsonitem.Address1+' '+jsonitem.Address2+' '+jsonitem.Address3+' '+jsonitem.Address4+' '+jsonitem.Address5;
            self.Region=jsonitem.Region;
			var pcbDate=jsonitem.PCB_Valid_Date;
			var PCB=pcbDate.split(' ');
            self.PCB_Valid_Date=PCB[0];
			var memDate=jsonitem.Membership_Valid_Date;
			var MVD=memDate.split(' ');
            self.Membership_Valid_Date=MVD[0];
			self.Is_Quantity_Input=jsonitem.Is_Quantity_Input;
            //console.log(self.siteCode);
          }
		});  
		
		var token=localStorage.getItem("auth");
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));	  
			var requestInfo = {	
		  Token:token,
		  Session_User_Id:Session_User_Id,
		  Site_Code:self.siteCode,
		  Customer_Code:self.siteCustomerCode,
		};
		var data = JSON.stringify(requestInfo);					
		var config = {
		  method: 'post',
		  url: apiURL+'MasterData/GetWasteList',
		  headers: { 
		  'Content-Type': 'application/json'
		  },
		  data : data
		  };
		  this.isLoading = true;
		  axios(config)
		  .then((result) => {
			  this.isLoading = false;	
			if(result.data.status_code==200){
			  var wasteDataArr=result.data.response;
			  //console.log(wasteDataArr);

			  this.wasteArr=wasteDataArr;
			  var wasteSingleArr=[];
			  var selArr = wasteDataArr.find(function(jsonitem, i){
					var process_rate_dec=parseInt(jsonitem.Process_Rate).toLocaleString();
				  wasteSingleArr.push(jsonitem.Material_Code+'-'+jsonitem.Material_Name+'-'+jsonitem.Physical_Status+'-(₹'+process_rate_dec+')');		
				  //wasteSingleArr.push(jsonitem.Material_Code);				
			  });		                  
				this.wastename = { val: '' };
				this.wastename=wasteSingleArr;	                  

				/* GET OUTSTANDING */
				//var self1=self;
				var config = {
				  method: 'post',
				  url: apiURL+'MasterData/GetOutstandingBalance',
				  headers: { 
				  'Content-Type': 'application/json'
				},
				  data : data
				};
				this.isLoading = true;
				axios(config)
				.then((result) => {	
					this.isLoading = false;
					  if(result.data.status_code==200){
						var outstandingDataArr=result.data.response;
						//console.log(oldestDataArr);

						this.outstanding_amt=parseInt(outstandingDataArr[0].OutStanding_Amnt).toLocaleString();
						this.outTitle=outstandingDataArr[0].Customer_No+' '+outstandingDataArr[0].Customer_Name;
						this.days30=parseInt(outstandingDataArr[0].Days_030).toLocaleString();
						this.days60=parseInt(outstandingDataArr[0].Days_3160).toLocaleString();
						this.days180=parseInt(outstandingDataArr[0].Days_61180).toLocaleString();
						this.days270=parseInt(outstandingDataArr[0].Days_181270).toLocaleString();
						this.days365=parseInt(outstandingDataArr[0].Days_271365).toLocaleString();
						this.days365up=parseInt(outstandingDataArr[0].Days_More_365).toLocaleString();	  
						//console.log(outstandingDataArr);
										  

					  }else{				                
						this.$swal.fire({
						  icon: 'error',
						  title: 'Oops...',
						  text: result.data.message		 
						})
					  }
					  
					}).catch((error) => { 
					  this.isLoading = false;           
					  this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'Something went wrong!'		 
					  })
					});

				}
				/* GET OUTSTANDING OVER */
				
				/* GET OLD BILL */
				//var self1=self;
				var requestInfo = {	
				  Token:token,
				  Session_User_Id:Session_User_Id,
				  Plant_Code:self.Plant_Code,
				  Customer_Code:self.siteCustomerCode,
				};
				//console.log(requestInfo);
				var datao = JSON.stringify(requestInfo);	
				var config = {
				  method: 'post',
				  url: apiURL+'MasterData/GetOldBillAmnt',
				  headers: { 
				  'Content-Type': 'application/json'
				},
				  data : datao
				};
				this.isLoading = true;
				axios(config)
				.then((result) => {	
					this.isLoading = false;
					if(result.data.status_code==200){
					var GetOldBillAmnt=result.data.response;				
					//console.log(GetOldBillAmnt);
					this.oldest_os_amt=parseInt(GetOldBillAmnt[0].OutStanding_Amnt).toLocaleString();
					this.oldest_days=GetOldBillAmnt[0].Days;
					if(GetOldBillAmnt[0].SD_Document_No==''){
					this.invoice_number=GetOldBillAmnt[0].FI_Document_No;
					}else{
					this.invoice_number=GetOldBillAmnt[0].SD_Document_No;
					}
				  }else{				                
					this.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: result.data.message		 
					})
				  }
				}).catch((error) => {
					this.isLoading = false;            
				  this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Something went wrong!'		 
				  })
				});                   
				/* GET OLD BILL OVER*/
			  })                                        
			  .catch((error) => { 
				  this.isLoading = false;            
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: 'Something went wrong!'		 
				})
			  });

			$('.counterDiv').show();
			$('.otherOptions').show();         
        	
			if(self.Is_Quantity_Input=='T'){
				$('#VehicleCapacity').show();
				$('#capacitySel').hide();
			}else{
				$('#VehicleCapacity').hide();
				$('#capacitySel').show();
			}
	},
	capacitySel(value) {		
		this.Quentity=value;		
	},
	shipmentSel(value) {		
		this.Shipment=value;		
	}, 
	packagingSel(value) {			
		this.Packaging=value;		
	},
	textureSel(value) {			
		this.Texture=value;		
	},
	truckTypeSel(value) {		
		this.TruckType=value;		
	},	
	agentinfo(){		
		this.myModal= true;
	},
	wasteSel(value) {		
     	var token=localStorage.getItem("auth");
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var self=this;
       //var waste_code = '';
       var selArr = this.wasteArr.find(function(jsonitem, i){
			var process_rate_dec=parseInt(jsonitem.Process_Rate).toLocaleString();		
			var wasteName=jsonitem.Material_Code+'-'+jsonitem.Material_Name+'-'+jsonitem.Physical_Status+'-(₹'+process_rate_dec+')';
			//console.log(wasteName);
          if(wasteName==value){
           // console.log(jsonitem.Physical_Status);
            //$('input[name=physicalStatus]').val(jsonitem.Physical_Status);
			self.physicalStatus=jsonitem.Physical_Status;
            self.Material_Name=jsonitem.Material_Name;            
            self.wasteCode=jsonitem.Material_Code;
             //waste_code=jsonitem.Waste_Code;
            //  console.log(self.siteCode)
            //  console.log(self.siteCustomerCode)
           
        var requestInfo = {	
          Token:token,
          Session_User_Id:Session_User_Id,
          Site_Code:self.siteCode,
          Customer_Code:self.siteCustomerCode,
          Waste_Code:self.wasteCode,
        };

         var data = JSON.stringify(requestInfo);					
            var config = {
                  method: 'post',
                  url: apiURL+'MasterData/GetVehicleCapacity',
                  headers: { 
                  'Content-Type': 'application/json'
              },
              data : data
              };
			  this.isLoading = true;
              axios(config)
              .then((result) =>  {
				  this.isLoading = false;	
                if(result.data.status_code==200){
                  var vehicleDataArr=result.data.response;
                  //console.log(vehicleDataArr);

                  this.capacityArr=vehicleDataArr;
                  var vehicleSingleArr=[];
                  var selArr = vehicleDataArr.find(function(jsonitem, i){
					  var process_rate_dec=parseInt(jsonitem.Process_Rate).toLocaleString();
                      //wasteSingleArr.push(jsonitem.Material_Code+'-'+jsonitem.Material_Name+'-'+jsonitem.Physical_Status+'-(₹'+process_rate_dec+')');		
                      vehicleSingleArr.push(jsonitem.Vehicle_Capacity);				
                  });		
                  self.capacity=vehicleSingleArr;	
                  	

              }else{				
                //$('#reponse_error').html(result.data.message);
                this.$swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: result.data.message		 
                })
              }
              
            })
            .catch((error) => {
				this.isLoading = false;	
              //var errorObject=JSON.stringify(error.response.data.errors);			
              //console.log(errorObject);		   
              this.$swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!'		 
              })
            });

          }
    });                
	},
	submit(){
		//console.log('submit');
		var token=localStorage.getItem("auth");
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var user=JSON.parse(localStorage.getItem("user"));
		var UserName = user[0].UserName;		
		//var IPAddress=user[0].IPAddress;		
		//var Latitude=user[0].Latitude;
		//var Longitude=user[0].Longitude;
		var Remarks=$('#Remarks').val();
		var VehiclePlaceDate=$('#VehiclePlaceDate').val();
		var VehiclePlaceTime=$('#VehiclePlaceTime').val();
		var self=this;
		var physicalStatus=self.physicalStatus;
		if(physicalStatus==''){
			physicalStatus='-';
		}
		//var IPAddress=self.IPAddress;
		var Latitude=self.Latitude;
		var Longitude=self.Longitude;
		//var VehiclePlaceDate="2020-12-29";
		//var VehiclePlaceTime="11:30";
		
		var Quentity=0;
		if(self.Is_Quantity_Input=='T'){
			Quentity=$('#VehicleCapacity').val();
		}else{
			Quentity=self.Quentity;
		}
		
		if(Quentity==0 || Quentity==''){
			self.$swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Quentity not valid..!'		 
			})
			return false;
		}
		if (Quentity.search(/^\d*[.+]?\d*$/) == -1) {				
			self.$swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Quentity not valid..!'		 
			})
			return false;
		}
		
		var requestInfo = {	
			UserId:Session_User_Id,
			UserName:UserName,
			SiteName:self.Plant_Name,
			SiteCode:self.siteCode,
			PlantCode:self.Plant_Code,			
			CustomerName:self.siteCustomer_Name,
			CustomerCode:self.siteCustomerCode,
			CustomerAddress:self.CustomerAddress,
			WasteName:self.Material_Name,
			WasteType:self.wasteCode,
			WastePhysicalStatus:physicalStatus,
			VehiclePlaceDate:VehiclePlaceDate,
			VehiclePlaceTime:VehiclePlaceTime,
			Quentity:Quentity,
			Packaging:self.Packaging,
			Texture:self.Texture,
			TruckType:self.TruckType,
			Remarks:Remarks,
			Region:self.Region,
			Shipment:self.Shipment,
			Latitude:Latitude,
			Longitude:Longitude,
			Token:token,
			Session_User_Id:Session_User_Id,                             
        };
		console.log(requestInfo);
		return false;
		var data = JSON.stringify(requestInfo);								
			var config = {
			  method: 'post',
			  url: apiURL+'MasterData/PostWasteRequest',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		axios(config)
		.then(function (result) {			
			//console.log(result);								
			if(result.data.status_code==200){						
				self.$swal.fire(
					'Saved',
					result.data.message,
					'success'
				);
				$('.formData')[0].reset();
			}else{				
				//$('#reponse_error').html(result.data.message);				
				self.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch(function (error) {
			//var errorObject=JSON.stringify(error.response.data.errors);			
			//console.log(errorObject);		   
			self.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	},
	back(){
		this.$router.push({path:'waste_lifting_lists'})
	}
  }
}
</script>
